import React from 'react';
import { Navigate } from 'react-router-dom';

// Calendar settings now live in Admin → Integrations. This route is kept only
// so the Google OAuth redirect (/calendar-settings?connected=google|error=…)
// keeps working — it forwards into the Integrations Calendar section, carrying
// the OAuth query string along so the success/error toast still fires.
export default function CalendarSettings() {
  const q = window.location.search.replace(/^\?/, '');
  const target = `/admin?tab=integrations&section=calendar${q ? `&${q}` : ''}`;
  return <Navigate to={target} replace />;
}
